import clsx from 'clsx'
import CodeViewer from 'components/CodeViewer/CodeViewer'
import { formatJSON } from 'helpers/format'
import { SquareTerminalIcon } from 'lucide-react'
import { IdEventV4 } from 'models/event'

import { IdentificationUrlKeys } from '../../../types'
import { SmartSignalDefinition } from './SmartSignalRepresentation'

export const emulatorDefinition: SmartSignalDefinition<{ emulator?: IdEventV4['emulator'] }> = {
  key: 'emulator',
  label: 'Android emulator',
  extract: (e) => ({ emulator: e.emulator }),
  icon(e) {
    const p = this.extract(e)?.emulator
    return (
      <SquareTerminalIcon
        className={clsx('size-4', {
          'text-red-800': p,
        })}
      />
    )
  },
  details(e) {
    return (
      <CodeViewer
        value={formatJSON(this.extract(e))}
        withSearch={false}
        className={this.isDetected(e) ? 'bg-red-100 border-red-300' : 'bg-gray-100'}
      />
    )
  },
  isDetected(e) {
    const p = this.extract(e)?.emulator
    return p === true
  },
  isWeb: () => false,
  isMobile: () => true,
  searchFor: '"emulator":',
  documentationHash: '#android-emulator-detection',
  urlParamKey: IdentificationUrlKeys.Emulator,
}
